var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.catalogId)?_c('input-select',{staticClass:"mb-1",attrs:{"value":_vm.value,"disabled":_vm.disabled,"options":_vm.colorOptions,"placeholder":"Select a color"},on:{"input":(v) => this.$emit('input', v)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }